// Shared labels/helpers for the subscription admin modules (Features 3–14).
// Plain exports (no reactivity) so any view/store can reuse them — keeps the
// Arabic label maps and error handling in one place.

export const PLAN_TYPES = ['monthly', 'term1', 'term2', 'yearly'];

export const PLAN_LABELS = {
    monthly: 'شهري',
    term1: 'الترم الأول',
    term2: 'الترم الثاني',
    yearly: 'سنوي',
};

export const STATUS_LABELS = {
    pending: 'بانتظار الدفع',
    waiting_payment: 'مراجعة الدفع',
    active: 'مفعّل',
    expired: 'منتهي',
    cancelled: 'ملغي',
};

export const STATUS_BADGE = {
    pending: 'bg-secondary',
    waiting_payment: 'bg-warning text-dark',
    active: 'bg-success',
    expired: 'bg-danger',
    cancelled: 'bg-dark',
};

export const REQUEST_STATUS_LABELS = {
    pending: 'قيد المراجعة',
    approved: 'مقبول',
    rejected: 'مرفوض',
};

export const REQUEST_STATUS_BADGE = {
    pending: 'bg-warning text-dark',
    approved: 'bg-success',
    rejected: 'bg-danger',
};

export const TYPE_LABELS = {
    academic_year: 'سنة دراسية',
    course: 'كورس',
    AcademicYear: 'سنة دراسية',
    Course: 'كورس',
};

export function planLabel(type) { return PLAN_LABELS[type] ?? type; }
export function statusLabel(s) { return STATUS_LABELS[s] ?? s; }
export function statusBadge(s) { return STATUS_BADGE[s] ?? 'bg-secondary'; }
export function requestStatusLabel(s) { return REQUEST_STATUS_LABELS[s] ?? s; }
export function requestStatusBadge(s) { return REQUEST_STATUS_BADGE[s] ?? 'bg-secondary'; }

// Normalizes a subscribable_type ("App\\Models\\Course") or short alias to Arabic.
export function typeLabel(type) {
    if (!type) return '';
    const base = String(type).split('\\').pop();
    return TYPE_LABELS[base] ?? base;
}

export function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '—';
    const n = Number(value);
    if (Number.isNaN(n)) return '—';
    return n.toLocaleString('en-EG') + ' ج';
}

export function formatDate(value) {
    if (!value) return '—';
    const d = new Date(String(value).replace(' ', 'T'));
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('ar-EG', { year: 'numeric', month: 'short', day: 'numeric' });
}

// Pull the best human message out of an axios error (matches backend envelope).
export function apiError(error, fallback = 'حدث خطأ، حاول مرة أخرى') {
    return error?.response?.data?.message || fallback;
}
